'use strict';

const SELECTOR = 'js-linkable-select';

/**
 * Used for linking via dropdown (e.g. tags/categories dropdown)
 */
export function init() {
    document.addEventListener('change', ev => {
        if (ev.target.classList.contains(SELECTOR)) {
            window.location = ev.target.value;
        }
    });
}
